export const FabIconPresetAssetUrls = {
  sparkle: 'https://ch6qh5px7337o0sf.public.blob.vercel-storage.com/preset-fab-icons/sparkle-v1.svg',
  robot: 'https://djerfmjfwyescixz.public.blob.vercel-storage.com/never-delete/robot.svg',
  anagram: 'https://ch6qh5px7337o0sf.public.blob.vercel-storage.com/preset-fab-icons/anagram-v1.svg',
} as const

export type FabIconPresetId = keyof typeof FabIconPresetAssetUrls

const FabIconPresetUrlEntries = Object.entries(FabIconPresetAssetUrls) as Array<[FabIconPresetId, string]>

const FabIconPresetUrlMap = new Map<string, FabIconPresetId>(
  FabIconPresetUrlEntries.map(([presetId, url]) => [url, presetId])
)
const FabIconPresetUrlSet = new Set(FabIconPresetUrlEntries.map(([, url]) => url))

export function getFabIconPresetIdFromUrl(url: string | null | undefined): FabIconPresetId | null {
  if (!url) {
    return null
  }

  return FabIconPresetUrlMap.get(url) ?? null
}

export function isFabIconPresetUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false
  }

  return FabIconPresetUrlSet.has(url)
}
